import React, { useState, useEffect } from "react";
import { array, string } from "prop-types";
import { Link } from "@quintype/components";
import { connect } from "react-redux";
import { get } from "lodash";
import { parseUrl } from "query-string";

import "./footerMenuGroup.m.css";

const FooterMenuGroup = ({ links, className = "", language, currentPath, domainSlug, sketchesHost, sections }) => {
  const [location, setLocation] = useState(sketchesHost);

  useEffect(() => {
    setLocation(global.location.origin);
  }, []);

  const constructHref = (url) => {
    const params = parseUrl(currentPath);
    const redirectUrl = get(params, ["query", "callback-url"], location);

    return `${redirectUrl}${url}`;
  };

  return (
    <div styleName={`wrapper ${language === "en" ? "en-wrappper" : ""}`} className={`footer-menu-group ${className}`}>
      {links.map((item, index) => {
        if (item["item-type"] === "placeholder") {
          return (
            <span styleName="footer-menu-item" className="footer-menu-item">
              {item.title}
            </span>
          );
        } else if (item["item-type"] === "tag" || item["item-type"] === "entity") {
          const slugType = `${item["item-type"]}-slug`;
          const destUrl = `/topic/${item[slugType]}`;
          return (
            <Link href={constructHref(destUrl)} key={index} styleName="footer-menu-item" className="footer-menu-item">
              {item.title}
            </Link>
          );
        } else {
          return (
            <Link
              href={item.completeUrl}
              key={index}
              styleName="footer-menu-item"
              className="footer-menu-item"
              disableAjaxLinks={true}
              data-tracking-category="Footer Menu"
              data-tracking-action="Click"
              data-tracking-label={item.title}
            >
              {item.title}
            </Link>
          );
        }
      })}
    </div>
  );
};

const mapStateToProps = (state) => ({
  sections: get(state, ["qt", "config", "sections"], []),
  currentPath: get(state, ["qt", "currentPath"], ""),
  domainSlug: get(state, ["qt", "domainSlug"]),
  sketchesHost: get(state, ["qt", "config", "sketches-host"], "https://www.prothomalo.com"),
});

FooterMenuGroup.propTypes = {
  links: array,
  className: string,
  language: string,
  currentPath: string,
  domainSlug: string,
  sketchesHost: string,
  sections: array,
};

export default connect(mapStateToProps, null)(FooterMenuGroup);
